<template>
  <div class="flex flex-col gap-4" :class="errorShow ? 'error' : ''">
    <div
      class="grid lg:grid-cols-4 gap-[8px] sm:gap-8 lg:gap-[8px]"
      :class="options.length == 3 ? 'sm:grid-cols-3' : 'sm:grid-cols-2'"
    >
      <label
        v-for="option in options"
        :key="option.id"
        class="input-radio-button-wrapp relative h-14 sm:h-[72px] flex justify-center items-center text-sm text-current cursor-pointer group"
      >
        <input
          :type="inputType"
          :name="name"
          class="absolute w-0 h-0 opacity-0 peer"
          @change="$emit('input', option.id)"
        />
        <!-- background -->
        <span
          class="block absolute inset-0 border border-gray/20 peer-checked:bg-blue peer-checked:border-white peer-focus-visible:shadow-[0_0px_0px_5px_rgba(255,255,255,0.2)] group-hover:shadow-[0_0px_0px_5px_rgba(255,255,255,0.2)] peer-focus-visible:rounded-md group-hover:rounded-md duration-300"
        ></span>

        <svg
          class="w-0 h-3 opacity-0 peer-checked:w-4 peer-checked:mr-3 peer-checked:opacity-100 duration-300 z-10 stroke-2"
        >
          <use xlink:href="#icon-check" />
        </svg>
        <span class="relative z-10 whitespace-nowrap select-none">
          {{
          option.text
          }}
        </span>
      </label>
    </div>

    <p v-if="errorShow" class="text-xs text-red">{{ errorText }}</p>
  </div>
</template>

<script>
export default {
  name: 'inputCheckboxButton',
  props: {
    options: {
      type: Array,
      default: [],
    },
    name: String,
    value: String,
    errorShow: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: 'This field is required',
    },
    multiple: {
      type: Boolean,
    }
  },
  computed: {
    inputType() {
      return this.multiple ? 'checkbox' : 'radio'
    }
  }
}
</script>
